import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-R76G',
        },
    },
    host: 'www.zalando-lounge.nl',
});
